import { stringify } from "yaml";
const toYaml = (value) => stringify(value);
export {
  toYaml
};
//# sourceMappingURL=to-yaml.js.map
